import React from "react";
import FlightSegmentDetail from "./flightsegment";
import { Message } from "semantic-ui-react";

interface Props {
  flight: server.dto.Flight
  segments: server.dto.FlightSegment[]
  connectionTimes: server.dto.ConnectionTime[]

  // If it's guaranteed there are no edit/delete perms, the callbacks may be left out
  onSegmentEdit?: (segment: server.dto.FlightSegment) => void
  onSegmentDelete?: (segment: server.dto.FlightSegment) => void
}

export default class FlightSegmentList extends React.Component<Props> {
  getConnectionTimeFor = (start: number, end: number): string => this.props.connectionTimes.find(ct => ct.startSegmentId === start && ct.endSegmentId === end).duration.formatted;

  public render(): JSX.Element {
    return <div className="list-with-gaps card-layout">
      <div className="list-with-gaps-body">
        {this.props.segments.map((segment, idx) => {
          const noMoreEntries = idx + 1 === this.props.segments.length;
          const nextItem = noMoreEntries ? null : this.props.segments[idx + 1];
          const connectionTime = noMoreEntries ? null : this.getConnectionTimeFor(segment.id, nextItem.id);

          return <React.Fragment key={segment.id}>
            <FlightSegmentDetail
              flight={this.props.flight}
              segment={segment}
              onDeleteClicked={this.props.onSegmentDelete}
              onEditClicked={this.props.onSegmentEdit}
            />
            {connectionTime && <Message key={`${segment.id}_ct`} color="purple" className="margin-bottom-small">
              {`${connectionTime} ${RESX.Flight.BetweenFlights}`}
            </Message>}
          </React.Fragment>;
        })}
      </div>
    </div>;
  }
}
